import { withTranslation } from "react-i18next";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Feedback from "./feedback/Feedback";
import CtaPopup from "./CtaPopup";
import { getBaseUrl } from "../../../config";
import Auth from "../../../lib/Auth";
import Api from "../../../lib/Api";
import Register from "../../Auth/Register";
import Popup from "../../../lib/Popup";
import ReactGA from 'react-ga4';
import MoreInfo from "../../../lib/MoreInfo";
import SummarySidebar from "./SummarySidebar";
import SummaryParts from "./SummaryParts";
import SummaryGeo from "./SummaryGeo";
import Subscription from "../../../lib/Subscription";
import Locale from "../../../lib/Locale";
import FindBikeButton from "./FindBikeButton";

class Summary extends Component {
  constructor(props) {
    super(props);

    const hasGeoFit =
      this.props.selectedOne !== undefined &&
      this.props.selectedOne.geo_fit.bike_fit_target.saddle_height !== 0 &&
      this.props.selectedOne.geo_fit.bike_fit_target.saddle_setback !== 0 &&
      this.props.selectedOne.geo_fit.bike_fit_target.bike_drop !== 0;

    this.state = {
      loggedIn: Auth.isLoggedIn(),
      hasGeoFit: hasGeoFit,
      domain: getBaseUrl(),
      contactform: false,
      contactName: "",
      contactEmail: "",
      contactPhone: "",
      contactMessage: "",
      contactPostcode: "",
      contactDate: "",
      goBack: false,
      selected: this.props.selectedOne,
      appConfig: this.props.appConfig
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    var self = this;
    window.onscroll = function (e) {
      if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
        self.surveyPopUp();
      }
    };

    Subscription.checkSubscription("bikefinder").then((success) => {
      this.setState({ hasSubscription: success });
    });

  }

  subscriptionClicked = () => {
    Subscription.paywall("bikefinder", this.props.traject);
  };

  render() {
    let self = this;
    let appConfig = self.props.appConfig;

    var planTestButton = false;
    for (let v of Object.values(appConfig)) {
      if (v.key === "testride") {
        planTestButton = v.value === "true";
      }
    }
    var mtb = self.props.selectedOne;
    if (this.state.goBack) {
      return <Redirect to={Locale.getUrlForCurrentLocale("/advice/result")} />;
    }
    let title = self.props.t("Geometrische fit details");
    if (this.state.parts) {
      title = self.props.t("Onderdelen details");
    }
    if (this.state.contactform) {
      title = self.props.t("Vind verkooppunt");
    }

    // get store URL for brand
    /*
		var brand = mtb.bike_model.brand;
		var brandUrl = '';
		switch(brand) {
			case 'BMC':
				brandUrl = 'https://www.bmc-switzerland.com/stockists';
				break;
			case 'Cannondale':
				brandUrl = 'https://www.cannondale.com/nl_NL/Europe/Dealers-near-you.aspx';
				break;
			case 'Canyon':
				brandUrl = 'https://www.canyon.com/nl/';
				break;
			case 'CUBE':
				brandUrl = 'https://www.cube.eu/nl/dealer-search/';
				break;
			case 'Felt':
				brandUrl = 'https://eu-en.feltbicycles.com/pages/dealers';
				break;
			case 'Focus':
				brandUrl = 'https://www.focus-bikes.com/be_nl/store-locator/';
				break;
			case 'Merida':
				brandUrl = 'https://www.merida.nl/dealers/';
				break;
			case 'Orbea':
				brandUrl = 'https://www.orbea.com/be-nl/dealers/?country=NL';
				break;
			case 'Scott':
				brandUrl = 'https://www.scott-sports.com/nl/en/dealers/locator';
				break;
			case 'Specialized':
				brandUrl = 'https://www.specialized.com/nl/nl/store-finder';
				break;
			case 'Stevens':
				brandUrl = 'https://www.stevensbikes.de/2019/index.php?cou=NL&lang=nl_NL&dealermap';
				break;
			case 'Trek':
				brandUrl = 'https://www.trekbikes.com/nl/nl_NL/store-finder/';
				break;
			default:
				break;
		}
		*/

    var myArr = [1];
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }

    today = yyyy + "-" + mm + "-" + dd;
    var traject = self.props.traject;

    var summaryContent = myArr.map(function (item, i) {
      if (self.state.contactform) {
        return (
          <div className="row justify-content-center" key={i}>
            <div className="col-11 contact-form testride">
              <form onSubmit={self.handleContact}>
                <p>{self.props.t("MTBSummary_WhatDoYouNeedToKnow")}.</p>
                <p>{self.props.t("MTBSummary_Wesearch")}.</p>
                <p>{self.props.t("MTBSummary_YourContactInfo")}</p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>{self.props.t("MTBSummary_Name")} *</label>
                      <input
                        type="text"
                        name="txtName"
                        onChange={self.inputName}
                        className="form-control"
                        placeholder="Jouw naam *"
                        value={self.state.contactName}
                      />
                    </div>
                    <div className="form-group">
                      <label>{self.props.t("MTBSummary_Email")} *</label>
                      <input
                        type="email"
                        name="txtEmail"
                        onChange={self.inputEmail}
                        className="form-control"
                        placeholder="Jouw e-mail *"
                        value={self.state.contactEmail}
                      />
                    </div>
                    <div className="form-group">
                      <label>{self.props.t("MTBSummary_Phone")} *</label>
                      <input
                        type="text"
                        name="txtPhone"
                        onChange={self.inputPhone}
                        className="form-control"
                        placeholder="Jouw telefoon *"
                        value={self.state.contactPhone}
                      />
                    </div>
                    <div className="form-group">
                      <label>{self.props.t("MTBSummary_PostalCode")} *</label>
                      <input
                        type="text"
                        name="txtPostcode"
                        onChange={self.inputPostcode}
                        className="form-control"
                        placeholder="Jouw postcode *"
                        value={self.state.contactPostcode}
                      />
                    </div>
                    {/*
										<div className="form-group">
											<label>Gewenste datum voor testrit *</label>
											<input type="date" name="txtDate" onChange={self.inputDate} className="form-control" placeholder="Jouw postcode *" min={today} value={self.state.contactDate} />
										</div>
										*/}
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        {self.props.t("MTBSummary_AdditionalInfo")}:
                      </label>
                      <textarea
                        name="txtMsg"
                        onChange={self.inputMessage}
                        className="form-control textfield"
                        placeholder="Jouw bericht *"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    {/*
										<div className="form-group">
											<input type="checkbox" name="checkbox" onChange={self.inputCheckbox}/> Ik ga ermee akkoord dat mijn data opgeslagen wordt
										</div>
										*/}
                    <div className="form-group">
                      <input
                        type="submit"
                        name="btnSubmit"
                        className="btnContact"
                        value="Verstuur bericht"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        );
      }
      if (self.state.parts) {
        return (
          <SummaryParts
            hasSubscription={self.state.hasSubscription}
            traject={traject}
            mtb={mtb}
          />
        );
      } else {
        return (
          <SummaryGeo
            hasSubscription={self.state.hasSubscription}
            traject={traject}
            mtb={mtb}
            lastUsedMeasure={self.props.lastUsedMeasure}
            usage={self.props.usage}
            speed={self.props.speed}
            bikeType={self.props.bikeType}
            setMeasureBikefit={self.props.setMeasureBikefit}
            chosenIntegrationOption={self.props.chosenIntegrationOption}
          />
        );
      }
    });
    return (
      <div className="container-fluid main">
        <div className="info-overlay"></div>
        <div className="more-info">
          <i className="closeInfo fas fa-times"></i>
          <div className="more-info-container"></div>
        </div>
        <div className="postresult">
          {planTestButton ? (
            <CtaPopup
              title={this.props.t(
                "CtaPopup-Wil je deze fiets graag in het echt zien of uitproberen"
              )}
              text={this.props.t("CtaPopup-Graag helpen wij jou")}
              yesAction={this.selectContact}
            />
          ) : (
            <Feedback />
          )}
        </div>
        <div className="row result row-eq-height">
          <div className="col-12 top-bar">
            <div className="row">
              <div className="col-sm-3">
                <button className="back btn btn-link" onClick={this.goBack}>
                  <i className="fas fa-caret-left"></i>{" "}
                  {self.props.t("MTBSummary_BackToResults")}
                </button>
              </div>
              <div className="col-sm-9 text-lg-center">
                <h2>{title}</h2>
              </div>
              {/*
              <div
                className="col-4 col-lg-3 d-none d-md-flex"
                style={{ justifyContent: "flex-end" }}
              >
                <div className="col-6 col-sm-6 col-md-6 col-lg-4 text-left text-sm-center">

                  {!this.state.hasSubscription && (
                            <button
                              className="btn btn-primary"
                              onClick={this.subscriptionClicked}
                            >
                              {this.props.t("Result_Subscribe")}
                            </button>
                  )}
                  </div>
                  </div>
                */}
                <FindBikeButton
                  className={"btn btn-primary"}
                  item={mtb}
                  traject={traject}
                  source={"summary-sidebar"}
                />
            </div>
          </div>
          <SummarySidebar
            mtb={mtb}
            title={title}
            parts={this.state.parts}
            hasGeoFit={this.state.hasGeoFit}
            selectParts={this.selectParts}
            selectGeo={this.selectGeo}
            downloadReport={this.downloadReport}
            traject={traject}
            hasSubscription={this.state.hasSubscription}
            bikeType={self.props.bikeType}
            setMeasureBikefit={self.props.setMeasureBikefit}
            lastUsedMeasure={self.props.lastUsedMeasure}
          />
          <div className="col-sm-9 relative">
            {summaryContent}

            <div className="disclaimer">
              <p className="floatright">
                {self.props.t("MTBSummary_HowToUseAdvice")}.
                <span
                  className="disclaimer_link link moreInfo"
                  onClick={() => {
                    MoreInfo.show("info", "disclaimer");
                  }}
                >
                  {self.props.t("MTBSummary_MoreInfo")}{" "}
                  <i className="fas fa-info-circle"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  downloadReport = () => {
    if (this.state.loggedIn) {
      let post = {
        selectedOne: this.props.selectedOne,
        position: this.props.position,
        arm: this.props.arm,
        torso: this.props.romp,
        length: this.props.length,
        inner_leg_length: this.props.inner_leg,
        weight: this.props.weight,
        shoe: this.props.shoe_size,
        bike_cat: this.props.traject,
      };
      Api.post("/report", post, { base_url: this.state.domain }).then(() => {
        alert(this.props.t("MtbSummary_ReportSend"));
      });
    } else {
      this.showRegister(this.props.selectedOne.bike_model.bike_id);
    }
  };

  showRegister = (bike_id) => {
    ReactGA.event({
      action: "click",
      category: "show_registration_" + this.props.traject,
      label:
        this.props.selectedOne.bike_model.brand +
        " " +
        this.props.selectedOne.bike_model.model,
      value: this.props.selectedOne.bike_model.price,
    });

    let register = (
      <Register
        action={"report/" + bike_id}
        introText={this.props.t("MtbSummary_ReportRegisterIntro")}
      />
    );
    Popup.show(register);
  };

  selectGeo = () => {
    this.setState({ parts: false });
    this.setState({ contactform: false });
  };

  selectParts = () => {
    this.setState({ parts: true });
    this.setState({ contactform: false });
    this.surveyPopUp();
  };

  selectContact = () => {
    this.setState({ contactform: true });

    ReactGA.event({
      action: "click",
      category: "plan_test_drive_" + this.props.traject,
      label:
        this.props.selectedOne.bike_model.brand +
        " " +
        this.props.selectedOne.bike_model.model,
      value: this.props.selectedOne.bike_model.price,
    });
  };

  handleContact = (e) => {
    e.preventDefault();
    var name = this.state.contactName;
    var email = this.state.contactEmail;
    var phone = this.state.contactPhone;
    var message = this.state.contactMessage;
    var postcode = this.state.contactPostcode;
    // var date = this.state.contactDate;
    // var checked = this.state.contactCheck;
    var date = "disabled";
    var checked = true;
    var brand = this.props.selectedOne.bike_model.brand;
    var model = this.props.selectedOne.bike_model.model;
    var size = this.props.selectedOne.summary.bike_size;
    var session = localStorage.getItem("sessionId");
    if (!name || !email || !phone || !postcode || !date) {
      alert("Niet alle verplichte velden zijn ingevult");
    } else {
      if (checked) {
        ReactGA.event({
          action: "submit",
          category: "plan_test_drive_" + this.props.traject,
          label:
            this.props.selectedOne.bike_model.brand +
            " " +
            this.props.selectedOne.bike_model.model,
          value: this.props.selectedOne.bike_model.price,
        });

        Api.get("/sendcontact", {
          name: name,
          email: email,
          phone: phone,
          postcode: postcode,
          date: date,
          message: message,
          brand: brand,
          model: model,
          size: size,
          session: session,
        }).then((response) => {});
        this.setState({ parts: false });
        this.setState({ contactform: false });
      } else {
        alert(
          "Voor het inplannen van een testrit moet je akkoord gaan met het verwerken van uw data"
        );
      }
    }
  };

  inputName = (event) => {
    this.setState({ contactName: event.target.value });
  };
  inputEmail = (event) => {
    this.setState({ contactEmail: event.target.value });
  };
  inputPhone = (event) => {
    this.setState({ contactPhone: event.target.value });
  };
  inputMessage = (event) => {
    this.setState({ contactMessage: event.target.value });
  };
  inputPostcode = (event) => {
    this.setState({ contactPostcode: event.target.value });
  };
  inputDate = (event) => {
    this.setState({ contactDate: event.target.value });
  };
  inputCheckbox = (event) => {
    this.setState({ contactCheck: event.target.checked });
  };

  surveyPopUp = () => {
    // let finished = localStorage.getItem('finishedFeedback');
    // let currentFeedbackTime = Date.now();
    // if (!finished && (currentFeedbackTime - localStorage.getItem('lastFeedbackTime')) > 3600000) {
    // 	localStorage.setItem('lastFeedbackTime',currentFeedbackTime);
    // 	setTimeout(function(){
    // 		window.$('.postresult').show();
    // 	}, 2000);
    // }
  };

  goToStore = (event) => {
    event.preventDefault();
    this.surveyPopUp();

    ReactGA.event({
      action: "click",
      category: "find_store_" + this.props.traject,
      label:
        this.props.selectedOne.bike_model.brand +
        " " +
        this.props.selectedOne.bike_model.model,
      value: this.props.selectedOne.bike_model.price,
    });

    window.open(event.target.dataset.href, "_blank");
  };

  goBack = () => {
    this.props.goTo("/advice/result", this.props.traject);
  };
}

export default withTranslation("result")(Summary);
